import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";

const selectMenuProps = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  getContentAnchorEl: null,
};

const FlowBuilderAttendantModal = ({ open, onSave, data, onUpdate, close }) => {
  const m = useAerosModalStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  useEffect(() => {
    if (open === "edit") {
      (async () => {
        try {
          const user = data.data.user;
          const { data: result } = await api.get("/users");
          setUsers(result.users);
          setSelectedUser(user.id);
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    } else if (open === "create") {
      (async () => {
        try {
          const { data: result } = await api.get("/users");
          setUsers(result.users);
          setSelectedUser("");
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = () => {
    if (!selectedUser) {
      return toast.error(i18n.t("aeros.flow.modals.attendant.error"));
    }
    const user = users.find((item) => item.id === selectedUser);
    if (open === "edit") {
      onUpdate({
        ...data,
        data: {
          user: user ? user : "",
        },
      });
    } else if (open === "create") {
      onSave({
        user: user ? user : "",
      });
    }
    handleClose();
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={480}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.attendant.editTitle" : "aeros.flow.modals.attendant.addTitle")}
      onSubmit={handleSaveContact}
      submitLabel={i18n.t(open === "edit" ? "aeros.flow.save" : "aeros.flow.add")}
    >
      <div>
        <label className={m.fieldLabel} htmlFor="flow-attendant-select">
          {i18n.t("aeros.flow.modals.attendant.user")}
        </label>
        <TextField
          id="flow-attendant-select"
          select
          className={m.input}
          variant="outlined"
          value={selectedUser ?? ""}
          onChange={(e) => setSelectedUser(e.target.value)}
          SelectProps={{
            displayEmpty: true,
            MenuProps: selectMenuProps,
            renderValue: (v) => {
              const user = users.find((u) => u.id === v);
              return user ? user.name : i18n.t("aeros.flow.modals.attendant.placeholder");
            },
          }}
        >
          <MenuItem value="">
            <em>{i18n.t("aeros.flow.modals.attendant.placeholder")}</em>
          </MenuItem>
          {users.map((user) => (
            <MenuItem dense key={user.id} value={user.id}>
              {user.name}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </AerosDialog>
  );
};

export default FlowBuilderAttendantModal;
